import { dataLoader } from "@unbxd-ui/unbxd-react-components";

const utils = {
    addRequestConfigs: function(requestsMap = {}) {
        for (let requestId in requestsMap) {
            dataLoader.addRequestConfig(requestId, requestsMap[requestId]);
        }
    },
    capitalize: function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
}

export default utils;